module.exports = __webpack_public_path__ + "static/media/Umbreon_gaussian2.468e26be.png";